export default __webpack_public_path__ + "static/softwareworld-a63d335ec891eb5ace0e6eaa5049f7ca.svg";